module.exports = __webpack_public_path__ + "47bb0a78e74919294b676630678e4839.svg";